module.exports = __webpack_public_path__ + "img/Felsenbild.beedc7ca.svg";